import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Divider from '@mui/material/Divider';

interface TitleBarItemTravelerProps {
  disabled?: boolean;
  itemIndex: number;
  itemSize: number;
  onTravelItem: (direction: number) => void;
}

export function TitleBarItemTraveler(props: TitleBarItemTravelerProps) {
  const {
    disabled,
    itemIndex,
    itemSize,
    onTravelItem,
  } = props;

  return (
    <>
      <IconButton
        disabled={disabled || itemIndex <= 1}
        onClick={() => onTravelItem(-1)}
      >
        <ArrowBackIosIcon />
      </IconButton>
      {itemIndex}
      /
      {itemSize}
      <IconButton
        disabled={disabled || itemIndex >= itemSize}
        onClick={() => onTravelItem(1)}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </>
  );
}

interface TitleBarProps {
  title?: ReactNode;
  children?: ReactNode;
  hideActionButtons?: boolean;
}

export default function TitleBar(props: TitleBarProps) {
  const {
    title,
    children,
    hideActionButtons,
  } = props;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            typography: 'h7',
          }}
        >
          {title}
        </Box>

        <Box>
          { hideActionButtons ? null : children }
        </Box>
      </Box>
      <Divider sx={{ mb: 2 }} />
    </>
  );
}
